import { render, staticRenderFns } from "./activitygroupdetails.vue?vue&type=template&id=1803c046&scoped=true"
import script from "./activitygroupdetails.vue?vue&type=script&lang=js"
export * from "./activitygroupdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803c046",
  null
  
)

export default component.exports